// EndTurnModal.js

import React from 'react';
import { OptimizedModal } from './OptimizedModal'; // Yeni temel bileşen

// ✅ React.memo ile sarmalandı
export const EndTurnModal = React.memo(({ gameState, currentMaxAttacks, onConfirm, onCancel, isOpen }) => {
    const remainingAttacks = currentMaxAttacks - (gameState.attackCount || 0);
    const remainingExpansion = !gameState.hasExpanded ? 1 : 0;
    const totalRemaining = remainingAttacks + remainingExpansion;

    return (
        // ✅ OptimizedModal kullanıldı. Kapatma işlemi için onCancel kullanıldı.
        <OptimizedModal isOpen={isOpen} onClose={onCancel}>
            <div className="bg-gradient-to-br from-yellow-900 to-gray-900 border-4 border-orange-500 rounded-2xl p-6 text-center shadow-2xl w-full max-w-md">
                <h2 className="text-2xl font-bold mb-4 text-orange-300">⚠️ Turu Bitir</h2>
                <div className="mb-6 text-white text-left space-y-3 bg-black bg-opacity-30 p-4 rounded-lg">
                    <h3 className="text-yellow-400 font-bold mb-2 text-center">Hamle Durumu:</h3>

                    <div className="flex justify-between items-center p-2 bg-gray-800 bg-opacity-50 rounded">
                        <span className="text-sm">⚔️ Saldırı Hakları:</span>
                        <span className={`font-bold ${remainingAttacks > 0 ? 'text-red-400' : 'text-green-400'}`}>
                            {remainingAttacks} / {currentMaxAttacks}
                        </span>
                    </div>

                    <div className="flex justify-between items-center p-2 bg-gray-800 bg-opacity-50 rounded">
                        <span className="text-sm">➕ Bölge Genişletme:</span>
                        <span className={`font-bold ${remainingExpansion > 0 ? 'text-red-400' : 'text-green-400'}`}>
                            {remainingExpansion} / 1
                        </span>
                    </div>

                    {totalRemaining > 0 ? (
                        <div className="mt-3 p-2 bg-red-900 bg-opacity-30 rounded border border-red-500 border-opacity-50">
                            <p className="text-sm text-red-300 font-semibold">
                                Toplam {totalRemaining} hamle hakkınız kullanılmadı!
                            </p>
                        </div>
                    ) : (
                        <div className="mt-3 p-2 bg-green-900 bg-opacity-30 rounded border border-green-500 border-opacity-50">
                            <p className="text-sm text-green-300 font-semibold">
                                ✅ Tüm hamle haklarınızı kullandınız!
                            </p>
                        </div>
                    )}
                </div>

                <p className="mb-4 text-white text-base">
                    {totalRemaining > 0
                        ? "Kullanmadığınız hamleleriniz var. Yine de turu bitirmek istiyor musunuz?"
                        : "Tüm hamlelerinizi kullandınız. Turu bitirebilirsiniz."
                    }
                </p>

                <div className="flex gap-4">
                    <button
                        onClick={onCancel}
                        className="flex-1 p-3 text-sm rounded-lg bg-gray-600 hover:bg-gray-500 transition-all text-white font-semibold"
                    >
                        ⬅️ Geri Dön
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 p-3 rounded-lg font-bold text-black text-sm bg-gradient-to-r from-orange-400 to-yellow-400 hover:from-orange-500 hover:to-yellow-500 transition-all"
                    >
                        Turumu Bitir
                    </button>
                </div>
            </div>
        </OptimizedModal>
    );
});